import { colors } from '@ardoq/design-tokens';

export const MULTI_UNIT_GRID_LABEL_PADDING = 4;
export const GRID_LABELS_BOTTOM_ROW_HEIGHT = 24;
export const GRID_LABELS_TOP_ROW_HEIGHT = 32;
export const TIMELINE_GRID_COLOR = colors.grey300;
export const CROSSHAIR_LINE_HEIGHT = 20;
export const CROSSHAIR_PADDING_BOTTOM = 3;
export const CROSSHAIR_HEIGHT =
  CROSSHAIR_LINE_HEIGHT + CROSSHAIR_PADDING_BOTTOM;
export const CROSSHAIR_LABEL_PADDING_X = 5;
